module.exports = "/_next/static/images/3_5-78da1566.gif";